import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import barba from '@barba/core';
import { SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', async function () {
  // ************************************************************************************
  // Animation barba.js de transition entre les pages
  // ************************************************************************************
  const loader = document.querySelector('#transition-page');

  if (loader) {
    const logo = loader.querySelector('picture');

    gsap.set(loader, {
      transformOrigin: 'center',
      y: '100%',
      ease: 'cubic-bezier(0.64, 0.05, 0.35, 1)',
      duration: 1,
    });

    gsap.set(logo, {
      y: '-80%',
      ease: 'cubic-bezier(0.64, 0.05, 0.35, 1)',
      duration: 1,
    });

    barba.init({
      transitions: [{
        leave() {
          let animationsCompleted = 0;
          const done = this.async();

          function checkDone() {
            if (animationsCompleted === 2) {
              done();
            }
          }

          gsap.fromTo(loader, {
            y: '100%'
          }, {
            height: '100vh',
            y: '0%',
            onComplete: () => {
              window.scrollTo({
                top: 0,
                behavior: 'instant',
              });
              animationsCompleted++;
              checkDone();
            }
          });

          gsap.fromTo(logo, {
            y: '-80%'
          }, {
            y: '0%',
            onComplete: () => {
              animationsCompleted++;
              checkDone();
            }
          });
        },
        enter() {
          gsap.to(loader, {
            delay: 1,
            y: '-100%',
          });
          gsap.to(logo, {
            delay: 1,
            y: '80%',
          });
        }
      }]
    });


    //Reset scrollTrigger et animations on page transition
    barba.hooks.beforeEnter((data) => {
      //kill all scrollTrigger
      ScrollTrigger.getAll().forEach(t => t.kill());
      gsap.killTweensOf('.animation-img-scaling img');
      gsap.killTweensOf('.line-mask');
    });

    barba.hooks.afterEnter((data) => {
      let myDom = document;
      if (data.next.container instanceof HTMLElement) {
        myDom = data.next.container;
      }
      runAnimationText(myDom,barba);
      runAnimationImages(myDom);
      runAnimationSideBar();
      runAnimationBtnHover();
      runAnimationHoverLink();
      closeNavbar();

      //récupère la navbar dans la nouvelle page
      let newNavbar = data.next.container.querySelector('.navbar');
      checkNavbar(newNavbar);
    });
  }
});

function runAnimationText(domContainer = document, barba) {
  document.fonts.ready.then(function () {
    const headline = domContainer.querySelector('.js-animation-text-1');
    if (headline) {
      const split = new SplitText(headline, {type: "lines", linesClass: "line-wrapper"});
      const lines = split.lines;

      lines.forEach(function (line, index) {
        const lineMask = document.createElement('div');
        lineMask.classList.add('line-mask');
        line.appendChild(lineMask);

        gsap.fromTo(lineMask, {
          scaleX: 1,
          transformOrigin: 'right',
        }, {
          scaleX: 0,
          duration: 1,
          scrollTrigger: {
            trigger: lineMask,
            // markers: true,
            start: `top ${lines[2] ? lines[2].offsetTop : 0}px`,
            end: () => `+=${line.offsetHeight}`,
            scrub: 1,
            invalidateOnRefresh: true,
          }
        });
      });

      let resizeTimer;
      let lastWidth = window.innerWidth;

      window.addEventListener('resize', function () {
        if (window.innerWidth !== lastWidth) {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            split.revert();
            runAnimationText(domContainer,barba);
          }, 500);
          lastWidth = window.innerWidth;
        }
      });

      barba.hooks.beforeEnter((data) => {
        split.revert();
        gsap.killTweensOf('.line-mask');
      });
    }
  });
}

function runAnimationImages(domContainer = document){
  let containerImages = domContainer.querySelectorAll('.animation-img-scaling');

  containerImages.forEach(function (containerImage) {
    let image = containerImage.querySelector('img');

    // Fonction pour appliquer l'animation
    function applyAnimation() {
      gsap.to(image, {
        scrollTrigger: {
          trigger: image,
          // markers: true,
          scrub: true
        },
        scale: 1.2,
        ease: "power1.out",
      });
    }

    // Vérifiez si l'image est déjà chargée
    if (image.complete && image.naturalHeight !== 0) {
      applyAnimation();
    } else {
      // Sinon, attendez que l'image soit chargée
      image.addEventListener('load', applyAnimation);
    }
  });
}


// Fonction pour empêcher le défilement
function preventScroll(e) {
  e.preventDefault();
  e.stopPropagation();
  return false;
}
//Animation SideBar
function openNavbar(navbarSide = document.querySelector('#navbar-side')) {
  return new Promise((resolve) => {
    let links = navbarSide.querySelectorAll('.js-nav-link-anim');

    // Pour bloquer le défilement
    document.addEventListener('wheel', preventScroll, { passive: false });
    document.addEventListener('touchmove', preventScroll, { passive: false });

    if (links && links.length > 0) {
      gsap.set(links, {
        opacity: '0',
        y: '-8px',
      });
    }

    gsap.fromTo(navbarSide, {
      x: '-100%',
      duration: 6,
      display: 'none',
    }, {
      x: '0%',
      display: 'flex',
      onStart: () => {
        // passer l'opacité du backdrop à 1 et le passer en display block
        let backdrop = document.querySelector('.backdrop');
        gsap.set(backdrop, {
          display: 'block',
        });
        gsap.to(backdrop, {
          opacity: '0.7',
          duration: 0.3,
        });
      },
      onComplete: () => {
        if (links && links.length > 0){
          gsap.fromTo(links, {
            opacity: '0',
            ease: 'cubic-bezier(0.5, 1, 0.89, 1)',
            y: '-8px',
            duration: 0.3,
            stagger: 0.1,
          }, {
            opacity: '1',
            ease: 'cubic-bezier(0.5, 1, 0.89, 1)',
            y: '0',
            duration: 0.3,
            stagger: 0.1,
            onComplete: () => {
              navbarSide.classList.add('navbar-show');
              resolve(); // Résoudre la promesse une fois l'animation terminée
            }
          });
        }
      }
    });
  });
}
function closeNavbar(navbarSide = document.querySelector('#navbar-side')) {
  return new Promise((resolve) => {
    let navbarSideContent = navbarSide.querySelector('.navbar-side-content');

    // Pour réactiver le défilement
    document.removeEventListener('wheel', preventScroll);
    document.removeEventListener('touchmove', preventScroll);

    // Animation de fermeture
    gsap.fromTo(navbarSideContent, {
      opacity: '1',
      duration: 0.3,
      ease: 'cubic-bezier(0.5, 1, 0.89, 1)',
    }, {
      opacity: '0',
      ease: 'cubic-bezier(0.5, 1, 0.89, 1)',
      onComplete: () => {
        gsap.to(navbarSide, {
          x: '-100%',
          duration: 0.6,
          onStart: () => {
            // passer l'opacité du backdrop à 0 et le passer en display none
            let backdrop = document.querySelector('.backdrop');
            gsap.to(backdrop, {
              opacity: '0',
              duration: 0.6,
              onComplete: () => {
                gsap.set(backdrop, {
                  display: 'none',
                });
              }
            });
          },
          onComplete: () => {
            navbarSide.classList.remove('navbar-show');
            gsap.set(navbarSideContent, { opacity: '1' });
            resolve(); // Résoudre la promesse une fois l'animation terminée
          }
        });
      }
    });
  });
}
async function runAnimationSideBar() {

  // Animation de la sidebar
  let btnOpenNavbar = document.querySelectorAll('button[data-navbar-target]');
  let isAnimating = false;

  if (btnOpenNavbar && btnOpenNavbar.length > 0) {
    btnOpenNavbar.forEach(function (btn) {
      btn.addEventListener('click', async function () {
        if (!isAnimating) {
          isAnimating = true;

          let navbarSide = document.querySelector(btn.dataset.navbarTarget);

          if (!navbarSide.classList.contains('navbar-show')) {
            await openNavbar(navbarSide);
          } else {
            await closeNavbar(navbarSide);
          }

          isAnimating = false;
        }
      });
    });
  }

  //si la navbar est ouverte et qu'on clique en dehors de la navbar ou sur escape on la ferme
  document.addEventListener('click', async function (e) {
    let navbarSides = document.querySelectorAll('.navbar-side');

    for (const navbarSide of navbarSides) {
      let navbarSideContent = navbarSide.querySelector('.navbar-side-content');
      if (navbarSide.classList.contains('navbar-show') && !navbarSideContent.contains(e.target)) {
        await closeNavbar(navbarSide);
      }
    }
  });

  document.addEventListener('keydown', async function (e) {
    let navbarSides = document.querySelectorAll('.navbar-side');

    for (const navbarSide of navbarSides) {
      if (navbarSide.classList.contains('navbar-show') && e.key === 'Escape') {
        await closeNavbar(navbarSide);
      }
    }
  });
}
//Animation changement en navbar mobile au scroll
function checkNavbar(navbar = document.querySelector('#navbar')) {
  if (navbar) {
    //si on est en desktop au dessis de md
    if (window.innerWidth >= 768) {
      ScrollTrigger.config({
        autoRefreshEvents: 'DOMContentLoaded',
      })

      gsap.to(navbar, {
        scrollTrigger: {
          trigger: navbar,
          // markers: true,
          start: "bottom top",
          end: "bottom top",
          scrub: true,
        },
        onComplete: () => {
          gsap.fromTo(navbar, {
            y: '-100%',
          }, {
            y: '0%',
            duration: 0.2,
            onStart: () => {
              navbar.classList.remove('navbar-expand-md');
            },
            onComplete: () => {
              navbar.classList.remove('navbar-expand-md');
            }
          });
        },
        onReverseComplete: () => {
          gsap.fromTo(navbar, {
            y: '0%',
          }, {
            y: '-100%',
            duration: 0.2,
            onComplete: () => {
              navbar.classList.add('navbar-expand-md');
              gsap.to(navbar, {
                y: '0%',
              });
            }
          });
        }
      });
    } else {
      navbar.classList.remove('navbar-expand-md');
    }

    // Changement de couleur de la navbar au scroll selon la section
    changeColorNavbar();
    document.addEventListener('scroll', function () {
      changeColorNavbar();
    });

    function changeColorNavbar() {
      if (!navbar.classList.contains('navbar-expand-md')) {
        //on récupère la section à la même position que la navbar
        const element = document.elementFromPoint(navbar.offsetWidth / 2, navbar.offsetHeight +1);
        const section = element === document.querySelector('main') ? element : element.closest('main > *');
        if (!section) return;
        const colorSection = window.getComputedStyle(section).getPropertyValue('background-color');

        if (section && colorSection === 'rgb(0, 0, 0)') {
          navbar.classList.add('navbar-black');
          navbar.classList.remove('navbar-white');
        } else {
          navbar.classList.add('navbar-white');
          navbar.classList.remove('navbar-black');
        }
      } else {
        navbar.classList.remove('navbar-white');
        navbar.classList.add('navbar-black');
      }
    }
  }
}
function runAnimationBtnHover(){
  const btns = document.querySelectorAll('.btn');
  if (btns && btns.length > 0) {
    btns.forEach(function (btn) {
      let span = btn.querySelector('span')

      if (span) {
        //translate la fin du span à la fin du bouton
        btn.addEventListener('mouseenter', function () {
          gsap.to(span, {
            x: btn.offsetWidth - span.offsetWidth,
            duration: 0.3,
            ease: 'cubic-bezier(0.64, 0.05, 0.35, 1)',
          });
        });
        btn.addEventListener('mouseleave', function () {
          gsap.to(span, {
            x: 0,
            duration: 0.3,
            ease: 'cubic-bezier(0.64, 0.05, 0.35, 1)',
          });
        });
      }
    });
  }
}
function runAnimationHoverLink(){
  //tous les liens qui n'ont pas la class d-block
  const linksHoverOrange = document.querySelectorAll('.link-hover-orange, .news-consult a:not(.d-block)');
  if (linksHoverOrange && linksHoverOrange.length > 0) {
    for (const link of linksHoverOrange) {
      let isUnderline = window.getComputedStyle(link).getPropertyValue('text-decoration-line') === 'underline';
      let classUnderline = isUnderline ? 'text-decoration-underline' : '';
      const replacedValue = '$'

      //replace tous les espaces par des @ pour éviter que splitText ne split les mots
      link.textContent = link.textContent.replace(/ /g, replacedValue);

      let split = new SplitText(link, {type: "chars", charsClass: classUnderline});
      let chars = split.chars;

      chars.forEach(function (char) {
        if (char.textContent === replacedValue) {
          char.innerHTML = '&nbsp;';
        }
      });

      let color = window.getComputedStyle(link).getPropertyValue('color');
      let duration = 0.3;
      let stagger = duration / chars.length;

      link.addEventListener('mouseenter', async function () {
        gsap.killTweensOf(chars);
        await gsap.to(chars, {
          color: '#E6AC44',
          stagger: stagger,
          duration: 0,
          ease: 'cubic-bezier(0.64, 0.05, 0.35, 1)',
        });
      });

      link.addEventListener('mouseleave', async function () {
        gsap.killTweensOf(chars); // Supprime toutes les animations en cours sur les caractères
        gsap.to(chars, {
          color: color,
          stagger: -stagger,
          duration: 0,
          ease: 'cubic-bezier(0.64, 0.05, 0.35, 1)',
        });
      });
    }
  }
}
